import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as CheckoutActions from '@modules/checkout/CheckoutActions';
import {
    validateFields,
    FormErrors
} from '@components/Forms/partials/FormErrors';
import TextBox from '@components/Forms/partials/TextBox';
import materializeInput from '@components/Fn/materializeInput';

import { PostData } from '../fetchData';

class ForgotPasswordComponent extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.postURL = this.postURL.bind(this);
        this.validation = {
            email: {
                email: 1,
                required: 1
            }
        };
        this.state = {
            formErrors: {},
            loginError: '',
            noFormSubmit: false
        };
    }

    postURL(url, postData) {
        PostData(this.props.ENV_WEB_URL + url, postData).then(result => {
            const responseJson = result;
            if (responseJson.code == 'success') {
                if (this.props.checkout == 1) {
                    this.props.actions.setPassword(postData.email);
                } else {
                    this.props.userLogin.setPassword(postData.email);
                }
            } else {
                this.setState({
                    loginError: responseJson.errors,
                    noFormSubmit: false
                });
            }
        });
    }

    handleChange(event) {
        this.setState({
            loginError: '',
            formErrors: {}
        });
        const obj = {
            name: event.target.name,
            value: event.target.value
        };
        this.validation[obj.name].value = obj.value;
        this.setState({
            loginError: ''
        });
    }

    handleSubmit(event) {
        this.setState({
            loginError: '',
            formErrors: {}
        });
        let validator;
        validator = validateFields(this.validation);
        if (validator.isValid) {
            // Form submitted
            this.setState({ noFormSubmit: true });
            const url = '/forgot-password';
            const postData = {
                email: event.target.email.value,
                checkout: this.props.checkout
            };
            this.postURL(url, postData);
            event.preventDefault();
            return false;
        }
        if (validator.errors) {
            this.setState(
                {
                    formErrors: validator.errors
                },
                () => {
                    // callback function for setState
                    FormErrors.forceUpdate;
                }
            );
            event.preventDefault();
            return false;
        }
    }

    componentDidMount() {
        materializeInput();
    }

    render() {
        return (
            <div
                className={`block bg ${
                    this.props.checkout ? ' full-height' : ''
                }`}
            >
                <div className="header">
                    <h5 className="text-center">Enter email to continue</h5>
                </div>
                <div className="content">
                    <form
                        noValidate
                        onSubmit={this.handleSubmit}
                        className="form"
                    >
                        <div className="form-group form-group-material">
                            <label>Please enter your email id</label>
                            <TextBox
                                className="form-control"
                                name="email"
                                onChange={this.handleChange}
                                type="email"
                            />
                        </div>
                        <div
                            className={`error${
                                this.state.loginError ? ' show' : ''
                            }`}
                        >
                            <small>{this.state.loginError}</small>
                        </div>
                        <FormErrors formErrors={this.state.formErrors} />
                        <div className="form-group text-center">
                            <button
                                disabled={
                                    this.state.noFormSubmit
                                        ? this.state.noFormSubmit
                                        : false
                                }
                                className="btn btn-warning"
                                type="submit"
                            >
                                Forgot Password
                            </button>
                        </div>
                    </form>
                    {typeof this.props.actions !== 'undefined' ? (
                        <div>
                            Or{' '}
                            <button
                                href="#"
                                className="btn btn-link"
                                onClick={this.props.actions.login}
                            >
                                Login To Your Account
                            </button>
                        </div>
                    ) : (
                        <div>
                            Or{' '}
                            <button
                                href="#"
                                className="btn btn-link"
                                onClick={this.props.ownActions.loginComponent}
                            >
                                Login To Your Account
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const ForgotPassword = ({ props, methods }) => {
    return <ForgotPasswordComponent {...props} {...methods} />;
};

function mapStateToProps(state, ownProps) {
    // 2nd argument takes ownProps which was originally sent to this component
    return {
        props: {
            checkout: ownProps.checkout ? ownProps.checkout : 0,
            userLogin: ownProps.userLogin ? ownProps.userLogin : undefined,
            ENV_WEB_URL: state.initState.WEB_URL ? state.initState.WEB_URL : ''
        }
    };
}

function mapDispatchToProps(dispatch) {
    return {
        methods: {
            actions: bindActionCreators(CheckoutActions, dispatch)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
